import { SortOrder } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteResults.Types.SortOrder */
export { SortOrder };
/** CoStar.Api.SuiteResults.Types.ChangesSortField */
export var ChangesSortField;
(function (ChangesSortField) {
    ChangesSortField[ChangesSortField["ChangeDate"] = 0] = "ChangeDate";
    ChangesSortField[ChangesSortField["Address"] = 1] = "Address";
    ChangesSortField[ChangesSortField["NewValue"] = 2] = "NewValue";
    ChangesSortField[ChangesSortField["PreviousValue"] = 3] = "PreviousValue";
    ChangesSortField[ChangesSortField["ChangeType"] = 4] = "ChangeType";
    ChangesSortField[ChangesSortField["RemovalDate"] = 5] = "RemovalDate";
    ChangesSortField[ChangesSortField["NewStatus"] = 6] = "NewStatus";
    ChangesSortField[ChangesSortField["PreviousStatus"] = 7] = "PreviousStatus";
    ChangesSortField[ChangesSortField["NewPropertyManagement"] = 8] = "NewPropertyManagement";
    ChangesSortField[ChangesSortField["PreviousPropertyManagement"] = 9] = "PreviousPropertyManagement";
    ChangesSortField[ChangesSortField["NewLeasingCompany"] = 10] = "NewLeasingCompany";
    ChangesSortField[ChangesSortField["PreviousLeasingCompany"] = 11] = "PreviousLeasingCompany";
})(ChangesSortField || (ChangesSortField = {}));
/** CoStar.Api.SuiteResults.Types.ChangeType */
export var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["None"] = 0] = "None";
    ChangeType[ChangeType["SpaceAddition"] = 1] = "SpaceAddition";
    ChangeType[ChangeType["SpaceRemove"] = 2] = "SpaceRemove";
    ChangeType[ChangeType["RentalRateChange"] = 3] = "RentalRateChange";
    ChangeType[ChangeType["SaleStatusChange"] = 4] = "SaleStatusChange";
    ChangeType[ChangeType["PropertiesAddition"] = 5] = "PropertiesAddition";
    ChangeType[ChangeType["RentableBuildingAreaChange"] = 6] = "RentableBuildingAreaChange";
    ChangeType[ChangeType["PropertyManagementChange"] = 7] = "PropertyManagementChange";
    ChangeType[ChangeType["LeasingCompanyChange"] = 8] = "LeasingCompanyChange";
})(ChangeType || (ChangeType = {}));
/** CoStar.Api.SuiteResults.Types.Correction */
export var Correction;
(function (Correction) {
    Correction[Correction["Include"] = 0] = "Include";
    Correction[Correction["Discard"] = 1] = "Discard";
})(Correction || (Correction = {}));
/** CoStar.Api.SuiteResults.Types.AuditSource */
export var AuditSource;
(function (AuditSource) {
    AuditSource[AuditSource["None"] = 0] = "None";
    AuditSource[AuditSource["Property"] = 1] = "Property";
    AuditSource[AuditSource["Space"] = 2] = "Space";
    AuditSource[AuditSource["ForSale"] = 3] = "ForSale";
    AuditSource[AuditSource["Company"] = 4] = "Company";
})(AuditSource || (AuditSource = {}));
import { CurrencyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteResults.Types.CurrencyType */
export { CurrencyType };
import { SpaceUse } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.SpaceUse */
export { SpaceUse };
/** CoStar.Api.SuiteResults.Types.SpaceType */
export var SpaceType;
(function (SpaceType) {
    SpaceType[SpaceType["None"] = 0] = "None";
    SpaceType[SpaceType["Relet"] = 1] = "Relet";
    SpaceType[SpaceType["New"] = 2] = "New";
    SpaceType[SpaceType["Sublet"] = 3] = "Sublet";
    SpaceType[SpaceType["Assignment"] = 4] = "Assignment";
    SpaceType[SpaceType["Coworking"] = 9] = "Coworking";
})(SpaceType || (SpaceType = {}));
import { LeaseTermType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.LeaseTermType */
export { LeaseTermType };
/** CoStar.Api.SuiteResults.Types.OffMarketReason */
export var OffMarketReason;
(function (OffMarketReason) {
    OffMarketReason[OffMarketReason["None"] = 0] = "None";
    OffMarketReason[OffMarketReason["Withdrawn"] = 1] = "Withdrawn";
    OffMarketReason[OffMarketReason["Leased"] = 2] = "Leased";
    OffMarketReason[OffMarketReason["LeasedThroughOtherListing"] = 3] = "LeasedThroughOtherListing";
    OffMarketReason[OffMarketReason["Sold"] = 4] = "Sold";
    OffMarketReason[OffMarketReason["Renewal"] = 5] = "Renewal";
})(OffMarketReason || (OffMarketReason = {}));
import { AvailabilityType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.AvailabilityType */
export { AvailabilityType };
import { RateEscalationType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteResults.Types.RateEscalationType */
export { RateEscalationType };
/** CoStar.Api.SuiteResults.Types.SpaceTypeCategory */
export var SpaceTypeCategory;
(function (SpaceTypeCategory) {
    SpaceTypeCategory[SpaceTypeCategory["None"] = 0] = "None";
    SpaceTypeCategory[SpaceTypeCategory["Direct"] = 1] = "Direct";
    SpaceTypeCategory[SpaceTypeCategory["Sublet"] = 1] = "Sublet";
})(SpaceTypeCategory || (SpaceTypeCategory = {}));
import { PropertyType } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteResults.Types.PropertyType */
export { PropertyType };
import { PropertyGroupType } from "../../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.SuiteResults.Types.PropertyGroupType */
export { PropertyGroupType };
import { ConstructionStatus } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteResults.Types.ConstructionStatus */
export { ConstructionStatus };
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.SuiteResults.Types.AreaMeasure */
export { AreaMeasure };
/** CoStar.Api.SuiteResults.Types.PropertyGroupSubType */
export var PropertyGroupSubType;
(function (PropertyGroupSubType) {
    PropertyGroupSubType[PropertyGroupSubType["None"] = 0] = "None";
    PropertyGroupSubType[PropertyGroupSubType["AirportRetail"] = 1] = "AirportRetail";
    PropertyGroupSubType[PropertyGroupSubType["CommunityCenter"] = 2] = "CommunityCenter";
    PropertyGroupSubType[PropertyGroupSubType["LifestyleCenter"] = 3] = "LifestyleCenter";
    PropertyGroupSubType[PropertyGroupSubType["NeighborhoodCenter"] = 4] = "NeighborhoodCenter";
    PropertyGroupSubType[PropertyGroupSubType["OutletCenter"] = 5] = "OutletCenter";
    PropertyGroupSubType[PropertyGroupSubType["PowerCenter"] = 6] = "PowerCenter";
    PropertyGroupSubType[PropertyGroupSubType["RegionalMall"] = 7] = "RegionalMall";
    PropertyGroupSubType[PropertyGroupSubType["ThemeFestivalCenter"] = 8] = "ThemeFestivalCenter";
    PropertyGroupSubType[PropertyGroupSubType["StripCenter"] = 9] = "StripCenter";
    PropertyGroupSubType[PropertyGroupSubType["SuperRegionalMall"] = 10] = "SuperRegionalMall";
    PropertyGroupSubType[PropertyGroupSubType["RegionalPrime"] = 11] = "RegionalPrime";
    PropertyGroupSubType[PropertyGroupSubType["MajorUrbanCentre"] = 12] = "MajorUrbanCentre";
    PropertyGroupSubType[PropertyGroupSubType["UrbanCentre"] = 13] = "UrbanCentre";
    PropertyGroupSubType[PropertyGroupSubType["District"] = 14] = "District";
    PropertyGroupSubType[PropertyGroupSubType["SolusUnit"] = 15] = "SolusUnit";
    PropertyGroupSubType[PropertyGroupSubType["ShoppingPark"] = 16] = "ShoppingPark";
    PropertyGroupSubType[PropertyGroupSubType["RetailPark"] = 17] = "RetailPark";
    PropertyGroupSubType[PropertyGroupSubType["LeisurePark"] = 18] = "LeisurePark";
    PropertyGroupSubType[PropertyGroupSubType["OfficePark"] = 19] = "OfficePark";
    PropertyGroupSubType[PropertyGroupSubType["IndustrialPark"] = 20] = "IndustrialPark";
})(PropertyGroupSubType || (PropertyGroupSubType = {}));
/** CoStar.Api.SuiteResults.Types.RentRateType */
export var RentRateType;
(function (RentRateType) {
    RentRateType[RentRateType["AmountPerArea"] = 0] = "AmountPerArea";
    RentRateType[RentRateType["AmountPerMonth"] = 1] = "AmountPerMonth";
    RentRateType[RentRateType["AmountPerYear"] = 2] = "AmountPerYear";
})(RentRateType || (RentRateType = {}));
import { RentBasis } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.RentBasis */
export { RentBasis };
/** CoStar.Api.SuiteResults.Types.CompanyAssociationType */
export var CompanyAssociationType;
(function (CompanyAssociationType) {
    CompanyAssociationType[CompanyAssociationType["None"] = 0] = "None";
    CompanyAssociationType[CompanyAssociationType["TrueBuyer"] = 1] = "TrueBuyer";
    CompanyAssociationType[CompanyAssociationType["TrueSeller"] = 2] = "TrueSeller";
    CompanyAssociationType[CompanyAssociationType["BuyerBroker"] = 3] = "BuyerBroker";
    CompanyAssociationType[CompanyAssociationType["ListingBroker"] = 4] = "ListingBroker";
    CompanyAssociationType[CompanyAssociationType["Lender"] = 5] = "Lender";
    CompanyAssociationType[CompanyAssociationType["Owner"] = 6] = "Owner";
    CompanyAssociationType[CompanyAssociationType["SaleBroker"] = 7] = "SaleBroker";
})(CompanyAssociationType || (CompanyAssociationType = {}));
import { AreaType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteResults.Types.AreaType */
export { AreaType };
import { CreditRating } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteResults.Types.CreditRating */
export { CreditRating };
import { EmployeeGrowthType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteResults.Types.EmployeeGrowthType */
export { EmployeeGrowthType };
import { IndustryType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteResults.Types.IndustryType */
export { IndustryType };
/** CoStar.Api.SuiteResults.Types.LocationExpertiseLookup */
export var LocationExpertiseLookup;
(function (LocationExpertiseLookup) {
    LocationExpertiseLookup[LocationExpertiseLookup["None"] = 0] = "None";
    LocationExpertiseLookup[LocationExpertiseLookup["ArchitectureEngineering"] = 1] = "ArchitectureEngineering";
    LocationExpertiseLookup[LocationExpertiseLookup["Appraisal"] = 2] = "Appraisal";
    LocationExpertiseLookup[LocationExpertiseLookup["AreaAssociation"] = 3] = "AreaAssociation";
    LocationExpertiseLookup[LocationExpertiseLookup["LandlordRepsOffice"] = 4] = "LandlordRepsOffice";
    LocationExpertiseLookup[LocationExpertiseLookup["LandlordRepsIndustrial"] = 5] = "LandlordRepsIndustrial";
    LocationExpertiseLookup[LocationExpertiseLookup["InvestmentSalesBrokerage"] = 6] = "InvestmentSalesBrokerage";
    LocationExpertiseLookup[LocationExpertiseLookup["LandlordRepsLand"] = 7] = "LandlordRepsLand";
    LocationExpertiseLookup[LocationExpertiseLookup["LandlordRepsRetail"] = 8] = "LandlordRepsRetail";
    LocationExpertiseLookup[LocationExpertiseLookup["Consulting"] = 9] = "Consulting";
    LocationExpertiseLookup[LocationExpertiseLookup["Development"] = 10] = "Development";
    LocationExpertiseLookup[LocationExpertiseLookup["FinancialLending"] = 11] = "FinancialLending";
    LocationExpertiseLookup[LocationExpertiseLookup["GeneralContracting"] = 12] = "GeneralContracting";
    LocationExpertiseLookup[LocationExpertiseLookup["InstitutionalInvestment"] = 13] = "InstitutionalInvestment";
    LocationExpertiseLookup[LocationExpertiseLookup["InteriorDesign"] = 14] = "InteriorDesign";
    LocationExpertiseLookup[LocationExpertiseLookup["InvestmentOwnership"] = 15] = "InvestmentOwnership";
    LocationExpertiseLookup[LocationExpertiseLookup["Landscaping"] = 16] = "Landscaping";
    LocationExpertiseLookup[LocationExpertiseLookup["Maintenance"] = 17] = "Maintenance";
    LocationExpertiseLookup[LocationExpertiseLookup["Moving"] = 18] = "Moving";
    LocationExpertiseLookup[LocationExpertiseLookup["ProfessionalAssociation"] = 19] = "ProfessionalAssociation";
    LocationExpertiseLookup[LocationExpertiseLookup["PropertyManagement"] = 20] = "PropertyManagement";
    LocationExpertiseLookup[LocationExpertiseLookup["TenantRepsFlex"] = 21] = "TenantRepsFlex";
    LocationExpertiseLookup[LocationExpertiseLookup["TenantRepsOffice"] = 22] = "TenantRepsOffice";
    LocationExpertiseLookup[LocationExpertiseLookup["TenantRepsRetail"] = 23] = "TenantRepsRetail";
    LocationExpertiseLookup[LocationExpertiseLookup["LandlordRepsFlex"] = 24] = "LandlordRepsFlex";
    LocationExpertiseLookup[LocationExpertiseLookup["LandlordRepsResidential"] = 25] = "LandlordRepsResidential";
    LocationExpertiseLookup[LocationExpertiseLookup["TenantRepsIndustrial"] = 26] = "TenantRepsIndustrial";
    LocationExpertiseLookup[LocationExpertiseLookup["TenantRepsResidential"] = 27] = "TenantRepsResidential";
    LocationExpertiseLookup[LocationExpertiseLookup["LandlordRepsFullService"] = 28] = "LandlordRepsFullService";
    LocationExpertiseLookup[LocationExpertiseLookup["PropertyTaxConsulting"] = 30] = "PropertyTaxConsulting";
})(LocationExpertiseLookup || (LocationExpertiseLookup = {}));
import { NAICS } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.NAICS */
export { NAICS };
import { OwnerSuperType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.OwnerSuperType */
export { OwnerSuperType };
/** CoStar.Api.SuiteResults.Types.OwnerType */
export var OwnerType;
(function (OwnerType) {
    OwnerType[OwnerType["None"] = 0] = "None";
    OwnerType[OwnerType["CorporateUser"] = 1] = "CorporateUser";
    OwnerType[OwnerType["PublicReit"] = 2] = "PublicReit";
    OwnerType[OwnerType["Individual"] = 3] = "Individual";
    OwnerType[OwnerType["Government"] = 4] = "Government";
    OwnerType[OwnerType["BankFinance"] = 5] = "BankFinance";
    OwnerType[OwnerType["DeveloperOwnerNtl"] = 6] = "DeveloperOwnerNtl";
    OwnerType[OwnerType["PensionFund"] = 7] = "PensionFund";
    OwnerType[OwnerType["Insurance"] = 8] = "Insurance";
    OwnerType[OwnerType["Nonprofit"] = 9] = "Nonprofit";
    OwnerType[OwnerType["Endowment"] = 10] = "Endowment";
    OwnerType[OwnerType["InvestmentManager"] = 11] = "InvestmentManager";
    OwnerType[OwnerType["OtherUnknown"] = 12] = "OtherUnknown";
    OwnerType[OwnerType["SovereignWealthFund"] = 13] = "SovereignWealthFund";
    OwnerType[OwnerType["Reoc"] = 14] = "Reoc";
    OwnerType[OwnerType["ListedFunds"] = 15] = "ListedFunds";
    OwnerType[OwnerType["DeveloperOwnerRegional"] = 16] = "DeveloperOwnerRegional";
    OwnerType[OwnerType["Trust"] = 17] = "Trust";
    OwnerType[OwnerType["TenantsInCommon"] = 18] = "TenantsInCommon";
    OwnerType[OwnerType["PrivateReit"] = 19] = "PrivateReit";
    OwnerType[OwnerType["OtherPrivate"] = 20] = "OtherPrivate";
    OwnerType[OwnerType["EquityFunds"] = 21] = "EquityFunds";
    OwnerType[OwnerType["Educational"] = 22] = "Educational";
    OwnerType[OwnerType["Religious"] = 24] = "Religious";
    OwnerType[OwnerType["Medical"] = 25] = "Medical";
    OwnerType[OwnerType["SpecialServicer"] = 26] = "SpecialServicer";
})(OwnerType || (OwnerType = {}));
import { SIC } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.SIC */
export { SIC };
/** CoStar.Api.SuiteResults.Types.DemographicsDataSet */
export var DemographicsDataSet;
(function (DemographicsDataSet) {
    DemographicsDataSet[DemographicsDataSet["None"] = 0] = "None";
    DemographicsDataSet[DemographicsDataSet["USData"] = 1] = "USData";
    DemographicsDataSet[DemographicsDataSet["GBData"] = 2] = "GBData";
    DemographicsDataSet[DemographicsDataSet["CAData"] = 3] = "CAData";
})(DemographicsDataSet || (DemographicsDataSet = {}));
/** CoStar.Api.SuiteResults.Types.ProductRegion */
export var ProductRegion;
(function (ProductRegion) {
    ProductRegion[ProductRegion["None"] = 0] = "None";
    ProductRegion[ProductRegion["Search"] = 9] = "Search";
    ProductRegion[ProductRegion["Grid"] = 10] = "Grid";
})(ProductRegion || (ProductRegion = {}));
/** CoStar.Api.SuiteResults.Types.DataMask */
export var DataMask;
(function (DataMask) {
    DataMask[DataMask["None"] = 0] = "None";
    DataMask[DataMask["Count"] = 1] = "Count";
    DataMask[DataMask["Percent"] = 2] = "Percent";
    DataMask[DataMask["Year"] = 5] = "Year";
    DataMask[DataMask["PercentChange"] = 12] = "PercentChange";
})(DataMask || (DataMask = {}));
/** CoStar.Api.SuiteResults.Types.ForSaleExportFieldBitmap */
export var ForSaleExportFieldBitmap;
(function (ForSaleExportFieldBitmap) {
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["None"] = 0] = "None";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["Main"] = 1] = "Main";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["ExtendedMisc"] = 2] = "ExtendedMisc";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["PropertyAddress"] = 4] = "PropertyAddress";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["PropertyNotes"] = 8] = "PropertyNotes";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["SaleCompResult"] = 16] = "SaleCompResult";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["SaleCompNotes"] = 32] = "SaleCompNotes";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["SalesCompMultifamily"] = 64] = "SalesCompMultifamily";
    ForSaleExportFieldBitmap[ForSaleExportFieldBitmap["FloodZone"] = 128] = "FloodZone";
})(ForSaleExportFieldBitmap || (ForSaleExportFieldBitmap = {}));
/** CoStar.Api.SuiteResults.Types.PropertyExportFieldBitmap */
export var PropertyExportFieldBitmap;
(function (PropertyExportFieldBitmap) {
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["None"] = 0] = "None";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["Result"] = 1] = "Result";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["Search"] = 2] = "Search";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["ExtendedMisc"] = 4] = "ExtendedMisc";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["ExtendedAnalytic"] = 8] = "ExtendedAnalytic";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["ExtendedSpace"] = 16] = "ExtendedSpace";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["SaleCompany"] = 32] = "SaleCompany";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["Transits"] = 64] = "Transits";
    PropertyExportFieldBitmap[PropertyExportFieldBitmap["FloodZone"] = 128] = "FloodZone";
})(PropertyExportFieldBitmap || (PropertyExportFieldBitmap = {}));
/** CoStar.Api.SuiteResults.Types.SalesCompExportFieldBitmap */
export var SalesCompExportFieldBitmap;
(function (SalesCompExportFieldBitmap) {
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["None"] = 0] = "None";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["Main"] = 1] = "Main";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["ExtendedMisc"] = 2] = "ExtendedMisc";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["PropertyAddress"] = 4] = "PropertyAddress";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["PropertyNotes"] = 8] = "PropertyNotes";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["SaleCompResult"] = 16] = "SaleCompResult";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["SaleCompNotes"] = 32] = "SaleCompNotes";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["SalesCompMultifamily"] = 64] = "SalesCompMultifamily";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["FloodZone"] = 128] = "FloodZone";
    SalesCompExportFieldBitmap[SalesCompExportFieldBitmap["CompanyInfo"] = 256] = "CompanyInfo";
})(SalesCompExportFieldBitmap || (SalesCompExportFieldBitmap = {}));
/** CoStar.Api.SuiteResults.Types.OriginType */
export var OriginType;
(function (OriginType) {
    OriginType[OriginType["None"] = 0] = "None";
    OriginType[OriginType["Local"] = 1] = "Local";
    OriginType[OriginType["National"] = 2] = "National";
    OriginType[OriginType["Foreign"] = 3] = "Foreign";
})(OriginType || (OriginType = {}));
import { HotelClass } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.HotelClass */
export { HotelClass };
import { HotelScale } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.HotelScale */
export { HotelScale };
/** CoStar.Api.SuiteResults.Types.HotelLocationType */
export var HotelLocationType;
(function (HotelLocationType) {
    HotelLocationType[HotelLocationType["None"] = 0] = "None";
    HotelLocationType[HotelLocationType["Urban"] = 1] = "Urban";
    HotelLocationType[HotelLocationType["Suburban"] = 2] = "Suburban";
    HotelLocationType[HotelLocationType["Airport"] = 3] = "Airport";
    HotelLocationType[HotelLocationType["Interstate"] = 4] = "Interstate";
    HotelLocationType[HotelLocationType["Resort"] = 5] = "Resort";
    HotelLocationType[HotelLocationType["SmallMetroTown"] = 6] = "SmallMetroTown";
})(HotelLocationType || (HotelLocationType = {}));
import { ItemType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.ItemType */
export { ItemType };
/** CoStar.Api.SuiteResults.Types.SaleCategory */
export var SaleCategory;
(function (SaleCategory) {
    SaleCategory[SaleCategory["None"] = 0] = "None";
    SaleCategory[SaleCategory["Property"] = 1] = "Property";
    SaleCategory[SaleCategory["Land"] = 2] = "Land";
    SaleCategory[SaleCategory["Condo"] = 3] = "Condo";
    SaleCategory[SaleCategory["Portfolio"] = 4] = "Portfolio";
    SaleCategory[SaleCategory["Unknown"] = 5] = "Unknown";
    SaleCategory[SaleCategory["Auction"] = 6] = "Auction";
    SaleCategory[SaleCategory["LoanAuction"] = 7] = "LoanAuction";
})(SaleCategory || (SaleCategory = {}));
import { SalePriceStatus } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.SalePriceStatus */
export { SalePriceStatus };
import { SaleStatus } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.SaleStatus */
export { SaleStatus };
import { SaleType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.SaleType */
export { SaleType };
import { BuildingClass } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.BuildingClass */
export { BuildingClass };
import { LandType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteResults.Types.LandType */
export { LandType };
/** CoStar.Api.SuiteResults.Types.LocationType */
export var LocationType;
(function (LocationType) {
    LocationType[LocationType["None"] = 0] = "None";
    LocationType[LocationType["CBD"] = 1] = "CBD";
    LocationType[LocationType["Suburban"] = 2] = "Suburban";
    LocationType[LocationType["Downtown"] = 3] = "Downtown";
    LocationType[LocationType["Midtown"] = 4] = "Midtown";
    LocationType[LocationType["Outlying"] = 5] = "Outlying";
    LocationType[LocationType["Urban"] = 6] = "Urban";
})(LocationType || (LocationType = {}));
/** CoStar.Api.SuiteResults.Types.PortfolioType */
export var PortfolioType;
(function (PortfolioType) {
    PortfolioType[PortfolioType["None"] = 0] = "None";
    PortfolioType[PortfolioType["MultiProperty"] = 1] = "MultiProperty";
    PortfolioType[PortfolioType["BulkPortfolio"] = 2] = "BulkPortfolio";
    PortfolioType[PortfolioType["PartofMultiProperty"] = 3] = "PartofMultiProperty";
    PortfolioType[PortfolioType["PartOfBulkPortfolio"] = 4] = "PartOfBulkPortfolio";
    PortfolioType[PortfolioType["MultiCondo"] = 5] = "MultiCondo";
})(PortfolioType || (PortfolioType = {}));
/** CoStar.Api.SuiteResults.Types.PropertySubType */
export var PropertySubType;
(function (PropertySubType) {
    PropertySubType[PropertySubType["None"] = 0] = "None";
    PropertySubType[PropertySubType["FlexLightManufacturing"] = 1] = "FlexLightManufacturing";
    PropertySubType[PropertySubType["FlexResearchAndDevelopment"] = 2] = "FlexResearchAndDevelopment";
    PropertySubType[PropertySubType["FlexShowroom"] = 3] = "FlexShowroom";
    PropertySubType[PropertySubType["GeneralRetailAutoDealership"] = 4] = "GeneralRetailAutoDealership";
    PropertySubType[PropertySubType["GeneralRetailAutoRepair"] = 5] = "GeneralRetailAutoRepair";
    PropertySubType[PropertySubType["GeneralRetailBank"] = 6] = "GeneralRetailBank";
    PropertySubType[PropertySubType["GeneralRetailBar"] = 7] = "GeneralRetailBar";
    PropertySubType[PropertySubType["SpecialtyCarwash"] = 8] = "SpecialtyCarwash";
    PropertySubType[PropertySubType["GeneralRetailConvenienceStore"] = 9] = "GeneralRetailConvenienceStore";
    PropertySubType[PropertySubType["GeneralRetailDaycareCenter"] = 10] = "GeneralRetailDaycareCenter";
    PropertySubType[PropertySubType["GeneralRetailDrugstore"] = 11] = "GeneralRetailDrugstore";
    PropertySubType[PropertySubType["GeneralRetailFastFood"] = 12] = "GeneralRetailFastFood";
    PropertySubType[PropertySubType["GeneralRetailFuneralHome"] = 13] = "GeneralRetailFuneralHome";
    PropertySubType[PropertySubType["GeneralRetailFreestanding"] = 14] = "GeneralRetailFreestanding";
    PropertySubType[PropertySubType["GeneralRetailGardenCenter"] = 15] = "GeneralRetailGardenCenter";
    PropertySubType[PropertySubType["SpecialtyParkingGarage"] = 16] = "SpecialtyParkingGarage";
    PropertySubType[PropertySubType["SpecialtyParkingLot"] = 17] = "SpecialtyParkingLot";
    PropertySubType[PropertySubType["GeneralRetailRestaurant"] = 18] = "GeneralRetailRestaurant";
    PropertySubType[PropertySubType["GeneralRetailServiceStation"] = 19] = "GeneralRetailServiceStation";
    PropertySubType[PropertySubType["GeneralRetailStorefront"] = 20] = "GeneralRetailStorefront";
    PropertySubType[PropertySubType["GeneralRetailStorefrontRetailOffice"] = 21] = "GeneralRetailStorefrontRetailOffice";
    PropertySubType[PropertySubType["GeneralRetailStorefrontRetailResidential"] = 22] = "GeneralRetailStorefrontRetailResidential";
    PropertySubType[PropertySubType["GeneralRetailSupermarket"] = 23] = "GeneralRetailSupermarket";
    PropertySubType[PropertySubType["GeneralRetailTruckStop"] = 24] = "GeneralRetailTruckStop";
    PropertySubType[PropertySubType["GeneralRetailVeterinarianKennel"] = 25] = "GeneralRetailVeterinarianKennel";
    PropertySubType[PropertySubType["HealthcareAssistedLiving"] = 26] = "HealthcareAssistedLiving";
    PropertySubType[PropertySubType["HealthcareCongregateSeniorHousing"] = 27] = "HealthcareCongregateSeniorHousing";
    PropertySubType[PropertySubType["HealthcareContinuingCareRetirementCommunity"] = 28] = "HealthcareContinuingCareRetirementCommunity";
    PropertySubType[PropertySubType["HealthcareHospital"] = 29] = "HealthcareHospital";
    PropertySubType[PropertySubType["HealthcareRehabilitationCenter"] = 30] = "HealthcareRehabilitationCenter";
    PropertySubType[PropertySubType["HealthcareSkilledNursingFacility"] = 31] = "HealthcareSkilledNursingFacility";
    PropertySubType[PropertySubType["HospitalityHotel"] = 32] = "HospitalityHotel";
    PropertySubType[PropertySubType["HospitalityHotelCasino"] = 33] = "HospitalityHotelCasino";
    PropertySubType[PropertySubType["HospitalityMotel"] = 34] = "HospitalityMotel";
    PropertySubType[PropertySubType["SpecialtyAirport"] = 35] = "SpecialtyAirport";
    PropertySubType[PropertySubType["SpecialtyAirplaneHangar"] = 36] = "SpecialtyAirplaneHangar";
    PropertySubType[PropertySubType["SpecialtyAutoSalvageFacility"] = 37] = "SpecialtyAutoSalvageFacility";
    PropertySubType[PropertySubType["SpecialtyCementGravelPlant"] = 38] = "SpecialtyCementGravelPlant";
    PropertySubType[PropertySubType["SpecialtyChemicalOilRefinery"] = 39] = "SpecialtyChemicalOilRefinery";
    PropertySubType[PropertySubType["IndustrialTelecomHotelDataHosting"] = 40] = "IndustrialTelecomHotelDataHosting";
    PropertySubType[PropertySubType["IndustrialDistribution"] = 41] = "IndustrialDistribution";
    PropertySubType[PropertySubType["IndustrialFoodProcessing"] = 42] = "IndustrialFoodProcessing";
    PropertySubType[PropertySubType["SpecialtyLandfill"] = 43] = "SpecialtyLandfill";
    PropertySubType[PropertySubType["IndustrialManufacturing"] = 44] = "IndustrialManufacturing";
    PropertySubType[PropertySubType["SpecialtyRailroadYard"] = 45] = "SpecialtyRailroadYard";
    PropertySubType[PropertySubType["IndustrialRefrigerationColdStorage"] = 46] = "IndustrialRefrigerationColdStorage";
    PropertySubType[PropertySubType["SpecialtySelfStorage"] = 47] = "SpecialtySelfStorage";
    PropertySubType[PropertySubType["SpecialtyShipyard"] = 48] = "SpecialtyShipyard";
    PropertySubType[PropertySubType["IndustrialShowroom"] = 49] = "IndustrialShowroom";
    PropertySubType[PropertySubType["IndustrialTruckTerminal"] = 50] = "IndustrialTruckTerminal";
    PropertySubType[PropertySubType["SpecialtyUtilitySubstation"] = 51] = "SpecialtyUtilitySubstation";
    PropertySubType[PropertySubType["IndustrialWarehouse"] = 52] = "IndustrialWarehouse";
    PropertySubType[PropertySubType["SpecialtyWaterTreatmentFacility"] = 53] = "SpecialtyWaterTreatmentFacility";
    PropertySubType[PropertySubType["MixedUse"] = 57] = "MixedUse";
    PropertySubType[PropertySubType["MultifamilyApartments"] = 58] = "MultifamilyApartments";
    PropertySubType[PropertySubType["MultifamilyManufacturedHousingMobileHomePark"] = 62] = "MultifamilyManufacturedHousingMobileHomePark";
    PropertySubType[PropertySubType["OfficeLoftCreativeSpace"] = 63] = "OfficeLoftCreativeSpace";
    PropertySubType[PropertySubType["OfficeMedical"] = 64] = "OfficeMedical";
    PropertySubType[PropertySubType["SpecialtyCemeteryMausoleum"] = 72] = "SpecialtyCemeteryMausoleum";
    PropertySubType[PropertySubType["SpecialtyCorrectionalFacility"] = 73] = "SpecialtyCorrectionalFacility";
    PropertySubType[PropertySubType["SpecialtyLodgeMeetingHall"] = 74] = "SpecialtyLodgeMeetingHall";
    PropertySubType[PropertySubType["SpecialtyMarina"] = 75] = "SpecialtyMarina";
    PropertySubType[PropertySubType["SpecialtyMovieRadioTVStudio"] = 76] = "SpecialtyMovieRadioTVStudio";
    PropertySubType[PropertySubType["SpecialtyPoliceFireStation"] = 77] = "SpecialtyPoliceFireStation";
    PropertySubType[PropertySubType["SpecialtyPostOffice"] = 78] = "SpecialtyPostOffice";
    PropertySubType[PropertySubType["SpecialtyPublicLibrary"] = 79] = "SpecialtyPublicLibrary";
    PropertySubType[PropertySubType["SpecialtyRadioTVTransmissionFacilities"] = 80] = "SpecialtyRadioTVTransmissionFacilities";
    PropertySubType[PropertySubType["SpecialtyReligiousFacility"] = 81] = "SpecialtyReligiousFacility";
    PropertySubType[PropertySubType["SpecialtySchools"] = 82] = "SpecialtySchools";
    PropertySubType[PropertySubType["SpecialtyTrailerCamperPark"] = 83] = "SpecialtyTrailerCamperPark";
    PropertySubType[PropertySubType["SpecialtyWineryVineyard"] = 84] = "SpecialtyWineryVineyard";
    PropertySubType[PropertySubType["SportsAndEntertainmentAmusementPark"] = 85] = "SportsAndEntertainmentAmusementPark";
    PropertySubType[PropertySubType["SportsAndEntertainmentBaseballField"] = 86] = "SportsAndEntertainmentBaseballField";
    PropertySubType[PropertySubType["GeneralRetailBowlingAlley"] = 87] = "GeneralRetailBowlingAlley";
    PropertySubType[PropertySubType["SportsAndEntertainmentCasino"] = 88] = "SportsAndEntertainmentCasino";
    PropertySubType[PropertySubType["SportsAndEntertainmentGolfCourseDrivingRange"] = 89] = "SportsAndEntertainmentGolfCourseDrivingRange";
    PropertySubType[PropertySubType["GeneralRetailHealthClub"] = 90] = "GeneralRetailHealthClub";
    PropertySubType[PropertySubType["SportsAndEntertainmentHorseStables"] = 91] = "SportsAndEntertainmentHorseStables";
    PropertySubType[PropertySubType["GeneralRetailMovieTheatre"] = 92] = "GeneralRetailMovieTheatre";
    PropertySubType[PropertySubType["SportsAndEntertainmentRacetrack"] = 93] = "SportsAndEntertainmentRacetrack";
    PropertySubType[PropertySubType["SportsAndEntertainmentSkatingRink"] = 94] = "SportsAndEntertainmentSkatingRink";
    PropertySubType[PropertySubType["SportsAndEntertainmentSwimmingPool"] = 95] = "SportsAndEntertainmentSwimmingPool";
    PropertySubType[PropertySubType["SportsAndEntertainmentTheaterConcertHall"] = 96] = "SportsAndEntertainmentTheaterConcertHall";
    PropertySubType[PropertySubType["IndustrialService"] = 97] = "IndustrialService";
    PropertySubType[PropertySubType["OfficeTelecomHotelDataHosting"] = 98] = "OfficeTelecomHotelDataHosting";
    PropertySubType[PropertySubType["FlexTelecomHotelDataHosting"] = 99] = "FlexTelecomHotelDataHosting";
    PropertySubType[PropertySubType["FlexLightDistribution"] = 104] = "FlexLightDistribution";
    PropertySubType[PropertySubType["SpecialtyWaterRetentionFacility"] = 105] = "SpecialtyWaterRetentionFacility";
    PropertySubType[PropertySubType["SpecialtySororityFraternityHouse"] = 106] = "SpecialtySororityFraternityHouse";
    PropertySubType[PropertySubType["HospitalitySingleRoomOccupancyHotel"] = 107] = "HospitalitySingleRoomOccupancyHotel";
    PropertySubType[PropertySubType["SpecialtyShelter"] = 108] = "SpecialtyShelter";
    PropertySubType[PropertySubType["SpecialtyRecyclingCenter"] = 109] = "SpecialtyRecyclingCenter";
    PropertySubType[PropertySubType["OfficeOfficeResidential"] = 110] = "OfficeOfficeResidential";
    PropertySubType[PropertySubType["OfficeOfficeLiveWorkUnit"] = 112] = "OfficeOfficeLiveWorkUnit";
    PropertySubType[PropertySubType["SpecialtyLumberyard"] = 113] = "SpecialtyLumberyard";
    PropertySubType[PropertySubType["OfficeIndustrialLiveWorkUnit"] = 114] = "OfficeIndustrialLiveWorkUnit";
    PropertySubType[PropertySubType["SpecialtyDriveInMovie"] = 115] = "SpecialtyDriveInMovie";
    PropertySubType[PropertySubType["GeneralRetailDepartmentStore"] = 116] = "GeneralRetailDepartmentStore";
    PropertySubType[PropertySubType["SpecialtyContractorStorageYard"] = 117] = "SpecialtyContractorStorageYard";
    PropertySubType[PropertySubType["OfficeBusinessPark"] = 118] = "OfficeBusinessPark";
    PropertySubType[PropertySubType["OfficeCallCenter"] = 119] = "OfficeCallCenter";
    PropertySubType[PropertySubType["OfficeD1"] = 120] = "OfficeD1";
    PropertySubType[PropertySubType["OfficeD2"] = 121] = "OfficeD2";
    PropertySubType[PropertySubType["OfficeServicedOffices"] = 122] = "OfficeServicedOffices";
    PropertySubType[PropertySubType["FlexBank"] = 123] = "FlexBank";
    PropertySubType[PropertySubType["FlexBusinessPark"] = 124] = "FlexBusinessPark";
    PropertySubType[PropertySubType["FlexCafe"] = 125] = "FlexCafe";
    PropertySubType[PropertySubType["FlexFoodCourt"] = 126] = "FlexFoodCourt";
    PropertySubType[PropertySubType["FlexMixedRetail"] = 127] = "FlexMixedRetail";
    PropertySubType[PropertySubType["FlexOutletCenter"] = 128] = "FlexOutletCenter";
    PropertySubType[PropertySubType["FlexPublicHouse"] = 129] = "FlexPublicHouse";
    PropertySubType[PropertySubType["FlexRetailOutOfTown"] = 130] = "FlexRetailOutOfTown";
    PropertySubType[PropertySubType["FlexSuperRegional"] = 131] = "FlexSuperRegional";
    PropertySubType[PropertySubType["FlexTradeCounterPark"] = 132] = "FlexTradeCounterPark";
    PropertySubType[PropertySubType["SportsAndEntertainmentAllLeisure"] = 133] = "SportsAndEntertainmentAllLeisure";
    PropertySubType[PropertySubType["SportsAndEntertainmentFitnessCenter"] = 134] = "SportsAndEntertainmentFitnessCenter";
    PropertySubType[PropertySubType["SportsAndEntertainmentNightclub"] = 135] = "SportsAndEntertainmentNightclub";
    PropertySubType[PropertySubType["SpecialtyConference"] = 136] = "SpecialtyConference";
    PropertySubType[PropertySubType["SpecialtyOfficeAndIndustrial"] = 137] = "SpecialtyOfficeAndIndustrial";
    PropertySubType[PropertySubType["IndustrialLightIndustrial"] = 139] = "IndustrialLightIndustrial";
    PropertySubType[PropertySubType["HealthcareIndependentLiving"] = 142] = "HealthcareIndependentLiving";
    PropertySubType[PropertySubType["MultifamilyDormitory"] = 143] = "MultifamilyDormitory";
    PropertySubType[PropertySubType["SpecialtyResidentialIncome"] = 144] = "SpecialtyResidentialIncome";
    PropertySubType[PropertySubType["OfficeBuilding"] = 145] = "OfficeBuilding";
    PropertySubType[PropertySubType["RetailBuilding"] = 146] = "RetailBuilding";
    PropertySubType[PropertySubType["StudentApartments"] = 190] = "StudentApartments";
    PropertySubType[PropertySubType["StudentManufacturedHousingMobileHomePark"] = 191] = "StudentManufacturedHousingMobileHomePark";
    PropertySubType[PropertySubType["StudentDormitory"] = 192] = "StudentDormitory";
})(PropertySubType || (PropertySubType = {}));
import { AdLevel } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteResults.Types.AdLevel */
export { AdLevel };
/** CoStar.Api.SuiteResults.Types.LeedType */
export var LeedType;
(function (LeedType) {
    LeedType[LeedType["None"] = 0] = "None";
    LeedType[LeedType["Certified"] = 1] = "Certified";
    LeedType[LeedType["CertifiedGold"] = 2] = "CertifiedGold";
    LeedType[LeedType["CertifiedPlatinum"] = 3] = "CertifiedPlatinum";
    LeedType[LeedType["CertifiedSilver"] = 4] = "CertifiedSilver";
    LeedType[LeedType["PreCertified"] = 5] = "PreCertified";
    LeedType[LeedType["Registered"] = 6] = "Registered";
})(LeedType || (LeedType = {}));
import { InvestmentType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.InvestmentType */
export { InvestmentType };
import { FundStatus } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteResults.Types.FundStatus */
export { FundStatus };
import { FundStrategy } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteResults.Types.FundStrategy */
export { FundStrategy };
import { FundStructure } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteResults.Types.FundStructure */
export { FundStructure };
import { ApartmentLifestyleType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteResults.Types.ApartmentLifestyleType */
export { ApartmentLifestyleType };
import { BuildingRating } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.BuildingRating */
export { BuildingRating };
/** CoStar.Api.SuiteResults.Types.SaleCondition */
export var SaleCondition;
(function (SaleCondition) {
    SaleCondition[SaleCondition["None"] = 0] = "None";
    SaleCondition[SaleCondition["DistressSale"] = 1] = "DistressSale";
    SaleCondition[SaleCondition["OneThousandThirtyOneExchange"] = 2] = "OneThousandThirtyOneExchange";
    SaleCondition[SaleCondition["SaleLeaseback"] = 3] = "SaleLeaseback";
    SaleCondition[SaleCondition["GroundLeaseLeasehold"] = 4] = "GroundLeaseLeasehold";
    SaleCondition[SaleCondition["GroundLeaseLeasedFee"] = 5] = "GroundLeaseLeasedFee";
    SaleCondition[SaleCondition["InvestmentTripleNet"] = 6] = "InvestmentTripleNet";
    SaleCondition[SaleCondition["DirectExchange"] = 7] = "DirectExchange";
    SaleCondition[SaleCondition["Assemblage"] = 8] = "Assemblage";
    SaleCondition[SaleCondition["AuctionSale"] = 9] = "AuctionSale";
    SaleCondition[SaleCondition["BuildToSuit"] = 11] = "BuildToSuit";
    SaleCondition[SaleCondition["BulkPortfolioSale"] = 12] = "BulkPortfolioSale";
    SaleCondition[SaleCondition["BusinessValueIncluded"] = 13] = "BusinessValueIncluded";
    SaleCondition[SaleCondition["CondoConversion"] = 14] = "CondoConversion";
    SaleCondition[SaleCondition["DeedRestriction"] = 15] = "DeedRestriction";
    SaleCondition[SaleCondition["EstateProbateSale"] = 16] = "EstateProbateSale";
    SaleCondition[SaleCondition["HistoricalSite"] = 17] = "HistoricalSite";
    SaleCondition[SaleCondition["LeaseOption"] = 18] = "LeaseOption";
    SaleCondition[SaleCondition["BuildingContaminationIssue"] = 19] = "BuildingContaminationIssue";
    SaleCondition[SaleCondition["DeferredMaintenance"] = 20] = "DeferredMaintenance";
    SaleCondition[SaleCondition["DoubleEscrow"] = 21] = "DoubleEscrow";
    SaleCondition[SaleCondition["ExerciseOfOption"] = 22] = "ExerciseOfOption";
    SaleCondition[SaleCondition["ExcessLand"] = 23] = "ExcessLand";
    SaleCondition[SaleCondition["Expansion"] = 24] = "Expansion";
    SaleCondition[SaleCondition["HighVacancyProperty"] = 25] = "HighVacancyProperty";
    SaleCondition[SaleCondition["LandContract"] = 26] = "LandContract";
    SaleCondition[SaleCondition["PartialInterestTransfer"] = 27] = "PartialInterestTransfer";
    SaleCondition[SaleCondition["PurchaseByTenant"] = 28] = "PurchaseByTenant";
    SaleCondition[SaleCondition["RedevelopmentProject"] = 29] = "RedevelopmentProject";
    SaleCondition[SaleCondition["RollingOptionTakedown"] = 30] = "RollingOptionTakedown";
    SaleCondition[SaleCondition["SoilContaminationIssue"] = 31] = "SoilContaminationIssue";
    SaleCondition[SaleCondition["BuildingInShellCondition"] = 32] = "BuildingInShellCondition";
    SaleCondition[SaleCondition["REOSale"] = 33] = "REOSale";
    SaleCondition[SaleCondition["ShortSale"] = 34] = "ShortSale";
    SaleCondition[SaleCondition["ThreatOfCondemnation"] = 35] = "ThreatOfCondemnation";
    SaleCondition[SaleCondition["CourtAppointedSale"] = 36] = "CourtAppointedSale";
    SaleCondition[SaleCondition["Recapitalization"] = 37] = "Recapitalization";
    SaleCondition[SaleCondition["DebtAssumption"] = 38] = "DebtAssumption";
    SaleCondition[SaleCondition["NotePurchase"] = 39] = "NotePurchase";
    SaleCondition[SaleCondition["BankruptcySale"] = 40] = "BankruptcySale";
    SaleCondition[SaleCondition["ZeroCashFlowInvestment"] = 41] = "ZeroCashFlowInvestment";
    SaleCondition[SaleCondition["LIHTC"] = 42] = "LIHTC";
    SaleCondition[SaleCondition["EntityBuyMembershipInterests"] = 43] = "EntityBuyMembershipInterests";
    SaleCondition[SaleCondition["CondoDeconversion"] = 44] = "CondoDeconversion";
    SaleCondition[SaleCondition["FurnitureFixturesAndEquipmentIncluded"] = 45] = "FurnitureFixturesAndEquipmentIncluded";
    SaleCondition[SaleCondition["HotelBrandChange"] = 46] = "HotelBrandChange";
    SaleCondition[SaleCondition["LongTermEncumbrance"] = 47] = "LongTermEncumbrance";
    SaleCondition[SaleCondition["ConversionProject"] = 48] = "ConversionProject";
    SaleCondition[SaleCondition["BuildinginLeaseUp"] = 49] = "BuildinginLeaseUp";
})(SaleCondition || (SaleCondition = {}));
/** CoStar.Api.SuiteResults.Types.CostarBuildingType */
export var CostarBuildingType;
(function (CostarBuildingType) {
    CostarBuildingType[CostarBuildingType["None"] = 0] = "None";
    CostarBuildingType[CostarBuildingType["Yes"] = 1] = "Yes";
    CostarBuildingType[CostarBuildingType["No"] = 3] = "No";
    CostarBuildingType[CostarBuildingType["Unresearched"] = 4] = "Unresearched";
    CostarBuildingType[CostarBuildingType["Assessment"] = 5] = "Assessment";
    CostarBuildingType[CostarBuildingType["DataSeed1"] = 6] = "DataSeed1";
    CostarBuildingType[CostarBuildingType["CompsReview"] = 7] = "CompsReview";
    CostarBuildingType[CostarBuildingType["DataSeed2"] = 8] = "DataSeed2";
})(CostarBuildingType || (CostarBuildingType = {}));
/** CoStar.Api.SuiteResults.Types.SubmarketLocationType */
export var SubmarketLocationType;
(function (SubmarketLocationType) {
    SubmarketLocationType[SubmarketLocationType["None"] = 0] = "None";
    SubmarketLocationType[SubmarketLocationType["CBD"] = 1] = "CBD";
    SubmarketLocationType[SubmarketLocationType["Suburban"] = 2] = "Suburban";
    SubmarketLocationType[SubmarketLocationType["Downtown"] = 3] = "Downtown";
    SubmarketLocationType[SubmarketLocationType["Midtown"] = 4] = "Midtown";
    SubmarketLocationType[SubmarketLocationType["Outlying"] = 5] = "Outlying";
    SubmarketLocationType[SubmarketLocationType["Urban"] = 6] = "Urban";
})(SubmarketLocationType || (SubmarketLocationType = {}));
import { SaleEntityType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.SaleEntityType */
export { SaleEntityType };
/** CoStar.Api.SuiteResults.Types.CompStatusType */
export var CompStatusType;
(function (CompStatusType) {
    CompStatusType[CompStatusType["None"] = 0] = "None";
    CompStatusType[CompStatusType["InProgress"] = 1] = "InProgress";
    CompStatusType[CompStatusType["ResearchCompleteNewInfo"] = 2] = "ResearchCompleteNewInfo";
    CompStatusType[CompStatusType["ResearchCompleteCorrection"] = 3] = "ResearchCompleteCorrection";
    CompStatusType[CompStatusType["ResearchComplete"] = 4] = "ResearchComplete";
    CompStatusType[CompStatusType["ClosedBySystem"] = 5] = "ClosedBySystem";
    CompStatusType[CompStatusType["Initial"] = 7] = "Initial";
    CompStatusType[CompStatusType["InvalidComp"] = 8] = "InvalidComp";
    CompStatusType[CompStatusType["ResearchCompleteClosedBySystem"] = 9] = "ResearchCompleteClosedBySystem";
    CompStatusType[CompStatusType["PublicRecord"] = 10] = "PublicRecord";
})(CompStatusType || (CompStatusType = {}));
/** CoStar.Api.SuiteResults.Types.PhoneType */
export var PhoneType;
(function (PhoneType) {
    PhoneType[PhoneType["None"] = 0] = "None";
    PhoneType[PhoneType["Office"] = 1] = "Office";
    PhoneType[PhoneType["Mobile"] = 2] = "Mobile";
    PhoneType[PhoneType["Fax"] = 3] = "Fax";
    PhoneType[PhoneType["Home"] = 4] = "Home";
    PhoneType[PhoneType["Pager"] = 5] = "Pager";
})(PhoneType || (PhoneType = {}));
/** CoStar.Api.SuiteResults.Types.BuildOutStatus */
export var BuildOutStatus;
(function (BuildOutStatus) {
    BuildOutStatus[BuildOutStatus["None"] = 0] = "None";
    BuildOutStatus[BuildOutStatus["RawSpace"] = 1] = "RawSpace";
    BuildOutStatus[BuildOutStatus["ShellSpace"] = 2] = "ShellSpace";
    BuildOutStatus[BuildOutStatus["PartialBuildOut"] = 3] = "PartialBuildOut";
    BuildOutStatus[BuildOutStatus["FullBuildOut"] = 4] = "FullBuildOut";
    BuildOutStatus[BuildOutStatus["SpaceSuite"] = 5] = "SpaceSuite";
})(BuildOutStatus || (BuildOutStatus = {}));
/** CoStar.Api.SuiteResults.Types.LeaseDealEntitySourceType */
export var LeaseDealEntitySourceType;
(function (LeaseDealEntitySourceType) {
    LeaseDealEntitySourceType[LeaseDealEntitySourceType["None"] = 0] = "None";
    LeaseDealEntitySourceType[LeaseDealEntitySourceType["CoStarLeaseDeal"] = 1] = "CoStarLeaseDeal";
    LeaseDealEntitySourceType[LeaseDealEntitySourceType["LeaseAnalysis"] = 2] = "LeaseAnalysis";
    LeaseDealEntitySourceType[LeaseDealEntitySourceType["UserEnteredComp"] = 3] = "UserEnteredComp";
})(LeaseDealEntitySourceType || (LeaseDealEntitySourceType = {}));
import { LeaseDealSourceType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.LeaseDealSourceType */
export { LeaseDealSourceType };
import { LeaseDealType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.LeaseDealType */
export { LeaseDealType };
import { LeaseType } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteResults.Types.LeaseType */
export { LeaseType };
/** CoStar.Api.SuiteResults.Types.ServiceType */
export var ServiceType;
(function (ServiceType) {
    ServiceType[ServiceType["None"] = 0] = "None";
    ServiceType[ServiceType["PlusCleaning"] = 1] = "PlusCleaning";
    ServiceType[ServiceType["PlusElectricAndClean"] = 2] = "PlusElectricAndClean";
    ServiceType[ServiceType["PlusElectric"] = 4] = "PlusElectric";
    ServiceType[ServiceType["UtilitiesAndChar"] = 5] = "UtilitiesAndChar";
    ServiceType[ServiceType["PlusAllUtilities"] = 6] = "PlusAllUtilities";
    ServiceType[ServiceType["FullServiceGross"] = 7] = "FullServiceGross";
    ServiceType[ServiceType["IndustrialGross"] = 8] = "IndustrialGross";
    ServiceType[ServiceType["ModifiedGross"] = 9] = "ModifiedGross";
    ServiceType[ServiceType["Net"] = 10] = "Net";
    ServiceType[ServiceType["Negotiable"] = 11] = "Negotiable";
    ServiceType[ServiceType["DoubleNet"] = 12] = "DoubleNet";
    ServiceType[ServiceType["TripleNet"] = 13] = "TripleNet";
    ServiceType[ServiceType["Tbd"] = 14] = "Tbd";
    ServiceType[ServiceType["TenantElectric"] = 15] = "TenantElectric";
    ServiceType[ServiceType["FullyRepairingAndInsuring"] = 16] = "FullyRepairingAndInsuring";
    ServiceType[ServiceType["InternalRepairingOnly"] = 17] = "InternalRepairingOnly";
    ServiceType[ServiceType["InternalRepairingAndInsuring"] = 18] = "InternalRepairingAndInsuring";
    ServiceType[ServiceType["FullServiceGrossNoPass"] = 19] = "FullServiceGrossNoPass";
})(ServiceType || (ServiceType = {}));
import { Exposure } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.Exposure */
export { Exposure };
/** CoStar.Api.SuiteResults.Types.LeaseEntityType */
export var LeaseEntityType;
(function (LeaseEntityType) {
    LeaseEntityType[LeaseEntityType["None"] = 0] = "None";
    LeaseEntityType[LeaseEntityType["SpaceForLease"] = 1] = "SpaceForLease";
    LeaseEntityType[LeaseEntityType["LandForLease"] = 2] = "LandForLease";
    LeaseEntityType[LeaseEntityType["Workspace"] = 3] = "Workspace";
})(LeaseEntityType || (LeaseEntityType = {}));
import { BuildOutConditionType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.BuildOutConditionType */
export { BuildOutConditionType };
/** CoStar.Api.SuiteResults.Types.HotelCorridorType */
export var HotelCorridorType;
(function (HotelCorridorType) {
    HotelCorridorType[HotelCorridorType["None"] = 0] = "None";
    HotelCorridorType[HotelCorridorType["Interior"] = 1] = "Interior";
    HotelCorridorType[HotelCorridorType["Exterior"] = 2] = "Exterior";
})(HotelCorridorType || (HotelCorridorType = {}));
import { HotelOperatingStatus } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.HotelOperatingStatus */
export { HotelOperatingStatus };
import { HotelOperationType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.HotelOperationType */
export { HotelOperationType };
import { HotelRating } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.HotelRating */
export { HotelRating };
/** CoStar.Api.SuiteResults.Types.SewerUtilitySubtype */
export var SewerUtilitySubtype;
(function (SewerUtilitySubtype) {
    SewerUtilitySubtype[SewerUtilitySubtype["None"] = 0] = "None";
    SewerUtilitySubtype[SewerUtilitySubtype["City"] = 18] = "City";
    SewerUtilitySubtype[SewerUtilitySubtype["County"] = 19] = "County";
    SewerUtilitySubtype[SewerUtilitySubtype["SepticField"] = 20] = "SepticField";
})(SewerUtilitySubtype || (SewerUtilitySubtype = {}));
import { ApartmentStyleType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.ApartmentStyleType */
export { ApartmentStyleType };
import { ApartmentRentType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteResults.Types.ApartmentRentType */
export { ApartmentRentType };
import { AffordableRentSubtype } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteResults.Types.AffordableRentSubtype */
export { AffordableRentSubtype };
import { RateUnitMeasure } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteResults.Types.RateUnitMeasure */
export { RateUnitMeasure };
import { PropertyLevel } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteResults.Types.PropertyLevel */
export { PropertyLevel };
import { Availability } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteResults.Types.Availability */
export { Availability };
/** CoStar.Api.SuiteResults.Types.RetailLocation */
export var RetailLocation;
(function (RetailLocation) {
    RetailLocation[RetailLocation["None"] = 0] = "None";
    RetailLocation[RetailLocation["HighStreet"] = 1] = "HighStreet";
    RetailLocation[RetailLocation["OutofTown"] = 2] = "OutofTown";
})(RetailLocation || (RetailLocation = {}));
/** CoStar.Api.SuiteResults.Types.ProposedLandUse */
export var ProposedLandUse;
(function (ProposedLandUse) {
    ProposedLandUse[ProposedLandUse["None"] = 0] = "None";
    ProposedLandUse[ProposedLandUse["Commercial"] = 1] = "Commercial";
    ProposedLandUse[ProposedLandUse["Industrial"] = 2] = "Industrial";
    ProposedLandUse[ProposedLandUse["Retail"] = 3] = "Retail";
    ProposedLandUse[ProposedLandUse["Office"] = 4] = "Office";
    ProposedLandUse[ProposedLandUse["MixedUse"] = 5] = "MixedUse";
    ProposedLandUse[ProposedLandUse["Multifamily"] = 6] = "Multifamily";
    ProposedLandUse[ProposedLandUse["Hospitality"] = 7] = "Hospitality";
    ProposedLandUse[ProposedLandUse["AirplaneHangar"] = 8] = "AirplaneHangar";
    ProposedLandUse[ProposedLandUse["Airport"] = 9] = "Airport";
    ProposedLandUse[ProposedLandUse["ApartmentUnits"] = 10] = "ApartmentUnits";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsCondo"] = 11] = "ApartmentUnitsCondo";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsDorms"] = 12] = "ApartmentUnitsDorms";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsSenior"] = 13] = "ApartmentUnitsSenior";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsSubsidized"] = 14] = "ApartmentUnitsSubsidized";
    ProposedLandUse[ProposedLandUse["AutoDealership"] = 15] = "AutoDealership";
    ProposedLandUse[ProposedLandUse["AutoRepair"] = 16] = "AutoRepair";
    ProposedLandUse[ProposedLandUse["AutoSalvageFacility"] = 17] = "AutoSalvageFacility";
    ProposedLandUse[ProposedLandUse["Bank"] = 18] = "Bank";
    ProposedLandUse[ProposedLandUse["Bar"] = 19] = "Bar";
    ProposedLandUse[ProposedLandUse["BaseballField"] = 20] = "BaseballField";
    ProposedLandUse[ProposedLandUse["BowlingAlley"] = 21] = "BowlingAlley";
    ProposedLandUse[ProposedLandUse["Carwash"] = 22] = "Carwash";
    ProposedLandUse[ProposedLandUse["Casino"] = 23] = "Casino";
    ProposedLandUse[ProposedLandUse["CementGravelPlant"] = 24] = "CementGravelPlant";
    ProposedLandUse[ProposedLandUse["CemeteryMausoleum"] = 25] = "CemeteryMausoleum";
    ProposedLandUse[ProposedLandUse["ChemicalOilRefinery"] = 26] = "ChemicalOilRefinery";
    ProposedLandUse[ProposedLandUse["CommunityCenter"] = 27] = "CommunityCenter";
    ProposedLandUse[ProposedLandUse["ContractorStorageYard"] = 28] = "ContractorStorageYard";
    ProposedLandUse[ProposedLandUse["ConvenienceStore"] = 29] = "ConvenienceStore";
    ProposedLandUse[ProposedLandUse["CorrectionalFacility"] = 30] = "CorrectionalFacility";
    ProposedLandUse[ProposedLandUse["DaycareCenter"] = 31] = "DaycareCenter";
    ProposedLandUse[ProposedLandUse["DepartmentStore"] = 32] = "DepartmentStore";
    ProposedLandUse[ProposedLandUse["Distribution"] = 33] = "Distribution";
    ProposedLandUse[ProposedLandUse["Drugstore"] = 34] = "Drugstore";
    ProposedLandUse[ProposedLandUse["FastFood"] = 35] = "FastFood";
    ProposedLandUse[ProposedLandUse["FoodProcessing"] = 36] = "FoodProcessing";
    ProposedLandUse[ProposedLandUse["FuneralHome"] = 37] = "FuneralHome";
    ProposedLandUse[ProposedLandUse["GardenCenter"] = 38] = "GardenCenter";
    ProposedLandUse[ProposedLandUse["GeneralFreestanding"] = 39] = "GeneralFreestanding";
    ProposedLandUse[ProposedLandUse["GolfCourseDrivingRange"] = 40] = "GolfCourseDrivingRange";
    ProposedLandUse[ProposedLandUse["Healthcare"] = 41] = "Healthcare";
    ProposedLandUse[ProposedLandUse["HealthClub"] = 42] = "HealthClub";
    ProposedLandUse[ProposedLandUse["HoldForDevelopment"] = 43] = "HoldForDevelopment";
    ProposedLandUse[ProposedLandUse["HoldForInvestment"] = 44] = "HoldForInvestment";
    ProposedLandUse[ProposedLandUse["HorseStables"] = 45] = "HorseStables";
    ProposedLandUse[ProposedLandUse["Hospital"] = 46] = "Hospital";
    ProposedLandUse[ProposedLandUse["Hotel"] = 47] = "Hotel";
    ProposedLandUse[ProposedLandUse["IndustrialLiveWorkUnit"] = 48] = "IndustrialLiveWorkUnit";
    ProposedLandUse[ProposedLandUse["IndustrialPark"] = 49] = "IndustrialPark";
    ProposedLandUse[ProposedLandUse["Landfill"] = 50] = "Landfill";
    ProposedLandUse[ProposedLandUse["LodgeMeetingHall"] = 51] = "LodgeMeetingHall";
    ProposedLandUse[ProposedLandUse["LoftCreativeSpace"] = 52] = "LoftCreativeSpace";
    ProposedLandUse[ProposedLandUse["Lumberyard"] = 53] = "Lumberyard";
    ProposedLandUse[ProposedLandUse["ManufacturedHomesMobileHomePark"] = 54] = "ManufacturedHomesMobileHomePark";
    ProposedLandUse[ProposedLandUse["Marina"] = 55] = "Marina";
    ProposedLandUse[ProposedLandUse["MasterPlannedCommunity"] = 56] = "MasterPlannedCommunity";
    ProposedLandUse[ProposedLandUse["Medical"] = 57] = "Medical";
    ProposedLandUse[ProposedLandUse["Motel"] = 58] = "Motel";
    ProposedLandUse[ProposedLandUse["MovieTheater"] = 59] = "MovieTheater";
    ProposedLandUse[ProposedLandUse["MovieRadioTVStudio"] = 60] = "MovieRadioTVStudio";
    ProposedLandUse[ProposedLandUse["NeighborhoodCenter"] = 61] = "NeighborhoodCenter";
    ProposedLandUse[ProposedLandUse["OfficePark"] = 62] = "OfficePark";
    ProposedLandUse[ProposedLandUse["OpenSpace"] = 63] = "OpenSpace";
    ProposedLandUse[ProposedLandUse["OutletCenter"] = 64] = "OutletCenter";
    ProposedLandUse[ProposedLandUse["ParkingGarage"] = 65] = "ParkingGarage";
    ProposedLandUse[ProposedLandUse["ParkingLot"] = 66] = "ParkingLot";
    ProposedLandUse[ProposedLandUse["PlannedUnitDevelopment"] = 67] = "PlannedUnitDevelopment";
    ProposedLandUse[ProposedLandUse["PoliceFireStation"] = 68] = "PoliceFireStation";
    ProposedLandUse[ProposedLandUse["PostOffice"] = 69] = "PostOffice";
    ProposedLandUse[ProposedLandUse["PowerCenter"] = 70] = "PowerCenter";
    ProposedLandUse[ProposedLandUse["PublicLibrary"] = 71] = "PublicLibrary";
    ProposedLandUse[ProposedLandUse["PublicPark"] = 72] = "PublicPark";
    ProposedLandUse[ProposedLandUse["PublicSwimmingPool"] = 73] = "PublicSwimmingPool";
    ProposedLandUse[ProposedLandUse["RandD"] = 74] = "RandD";
    ProposedLandUse[ProposedLandUse["Racetrack"] = 75] = "Racetrack";
    ProposedLandUse[ProposedLandUse["RadioTVTransmissionFacility"] = 76] = "RadioTVTransmissionFacility";
    ProposedLandUse[ProposedLandUse["RailroadYard"] = 77] = "RailroadYard";
    ProposedLandUse[ProposedLandUse["RecyclingCenter"] = 78] = "RecyclingCenter";
    ProposedLandUse[ProposedLandUse["RefrigerationColdStorage"] = 79] = "RefrigerationColdStorage";
    ProposedLandUse[ProposedLandUse["RegionalMall"] = 80] = "RegionalMall";
    ProposedLandUse[ProposedLandUse["RehabilitationCenter"] = 81] = "RehabilitationCenter";
    ProposedLandUse[ProposedLandUse["ReligiousFacility"] = 82] = "ReligiousFacility";
    ProposedLandUse[ProposedLandUse["Restaurant"] = 83] = "Restaurant";
    ProposedLandUse[ProposedLandUse["RetailWarehouse"] = 84] = "RetailWarehouse";
    ProposedLandUse[ProposedLandUse["Schools"] = 85] = "Schools";
    ProposedLandUse[ProposedLandUse["SelfStorage"] = 86] = "SelfStorage";
    ProposedLandUse[ProposedLandUse["ServiceStation"] = 87] = "ServiceStation";
    ProposedLandUse[ProposedLandUse["Shelter"] = 88] = "Shelter";
    ProposedLandUse[ProposedLandUse["Shipyard"] = 89] = "Shipyard";
    ProposedLandUse[ProposedLandUse["SingleFamilyDevelopment"] = 90] = "SingleFamilyDevelopment";
    ProposedLandUse[ProposedLandUse["SkatingRink"] = 91] = "SkatingRink";
    ProposedLandUse[ProposedLandUse["SpecialtyFestivalEntertainment"] = 92] = "SpecialtyFestivalEntertainment";
    ProposedLandUse[ProposedLandUse["Storefront"] = 93] = "Storefront";
    ProposedLandUse[ProposedLandUse["StorefrontRetailOffice"] = 94] = "StorefrontRetailOffice";
    ProposedLandUse[ProposedLandUse["StorefrontRetailResidential"] = 95] = "StorefrontRetailResidential";
    ProposedLandUse[ProposedLandUse["StripCenter"] = 96] = "StripCenter";
    ProposedLandUse[ProposedLandUse["Supermarket"] = 97] = "Supermarket";
    ProposedLandUse[ProposedLandUse["TheaterConcertHall"] = 98] = "TheaterConcertHall";
    ProposedLandUse[ProposedLandUse["TrailerCamperPark"] = 99] = "TrailerCamperPark";
    ProposedLandUse[ProposedLandUse["TruckStop"] = 100] = "TruckStop";
    ProposedLandUse[ProposedLandUse["TruckTerminal"] = 101] = "TruckTerminal";
    ProposedLandUse[ProposedLandUse["Unknown"] = 102] = "Unknown";
    ProposedLandUse[ProposedLandUse["UtilitySubstation"] = 103] = "UtilitySubstation";
    ProposedLandUse[ProposedLandUse["VeterinarianKennel"] = 104] = "VeterinarianKennel";
    ProposedLandUse[ProposedLandUse["Warehouse"] = 105] = "Warehouse";
    ProposedLandUse[ProposedLandUse["WaterRetentionFacility"] = 106] = "WaterRetentionFacility";
    ProposedLandUse[ProposedLandUse["WaterTreatmentFacility"] = 107] = "WaterTreatmentFacility";
    ProposedLandUse[ProposedLandUse["WineryVineyard"] = 108] = "WineryVineyard";
    ProposedLandUse[ProposedLandUse["AmusementPark"] = 109] = "AmusementPark";
    ProposedLandUse[ProposedLandUse["Agricultural"] = 110] = "Agricultural";
    ProposedLandUse[ProposedLandUse["Agribusiness"] = 111] = "Agribusiness";
    ProposedLandUse[ProposedLandUse["PastureRanch"] = 112] = "PastureRanch";
    ProposedLandUse[ProposedLandUse["Timberland"] = 113] = "Timberland";
    ProposedLandUse[ProposedLandUse["SingleFamilyResidence"] = 114] = "SingleFamilyResidence";
})(ProposedLandUse || (ProposedLandUse = {}));
import { LengthMeasure } from "../../../../CoStar/Api/Brokers/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.LengthMeasure */
export { LengthMeasure };
import { UtilityType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.UtilityType */
export { UtilityType };
import { Tenure } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteResults.Types.Tenure */
export { Tenure };
/** CoStar.Api.SuiteResults.Types.BelowMarketSaleReason */
export var BelowMarketSaleReason;
(function (BelowMarketSaleReason) {
    BelowMarketSaleReason[BelowMarketSaleReason["None"] = 0] = "None";
    BelowMarketSaleReason[BelowMarketSaleReason["ABIDeed"] = 1] = "ABIDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["AffidavitOfDeath"] = 2] = "AffidavitOfDeath";
    BelowMarketSaleReason[BelowMarketSaleReason["AssignmentOfLease"] = 4] = "AssignmentOfLease";
    BelowMarketSaleReason[BelowMarketSaleReason["BusinessSaleZeroReallocation"] = 7] = "BusinessSaleZeroReallocation";
    BelowMarketSaleReason[BelowMarketSaleReason["ChangeInTitleVesting"] = 8] = "ChangeInTitleVesting";
    BelowMarketSaleReason[BelowMarketSaleReason["ContractInstallmentSale"] = 9] = "ContractInstallmentSale";
    BelowMarketSaleReason[BelowMarketSaleReason["CorrectionDeed"] = 10] = "CorrectionDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["DatedSalePrice"] = 11] = "DatedSalePrice";
    BelowMarketSaleReason[BelowMarketSaleReason["DeedInLieuOfForeclosure"] = 12] = "DeedInLieuOfForeclosure";
    BelowMarketSaleReason[BelowMarketSaleReason["DevelopmentAuthoritySale"] = 13] = "DevelopmentAuthoritySale";
    BelowMarketSaleReason[BelowMarketSaleReason["EasementRightOfWay"] = 15] = "EasementRightOfWay";
    BelowMarketSaleReason[BelowMarketSaleReason["GiftDeed"] = 16] = "GiftDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["InterrelatedParties"] = 17] = "InterrelatedParties";
    BelowMarketSaleReason[BelowMarketSaleReason["MortgageReleaseOfMortgage"] = 21] = "MortgageReleaseOfMortgage";
    BelowMarketSaleReason[BelowMarketSaleReason["PackageSaleRandomAllocation"] = 25] = "PackageSaleRandomAllocation";
    BelowMarketSaleReason[BelowMarketSaleReason["PartnershipDissolution"] = 27] = "PartnershipDissolution";
    BelowMarketSaleReason[BelowMarketSaleReason["QuitclaimDeed"] = 28] = "QuitclaimDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["Rerecording"] = 29] = "Rerecording";
    BelowMarketSaleReason[BelowMarketSaleReason["RedevelopmentAgencySale"] = 30] = "RedevelopmentAgencySale";
    BelowMarketSaleReason[BelowMarketSaleReason["Refinance"] = 31] = "Refinance";
    BelowMarketSaleReason[BelowMarketSaleReason["RelatedPrincipals"] = 32] = "RelatedPrincipals";
    BelowMarketSaleReason[BelowMarketSaleReason["ReleaseOfCosigner"] = 33] = "ReleaseOfCosigner";
    BelowMarketSaleReason[BelowMarketSaleReason["RightOfWay"] = 35] = "RightOfWay";
    BelowMarketSaleReason[BelowMarketSaleReason["TrustDeed"] = 39] = "TrustDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["TrustTransfer"] = 40] = "TrustTransfer";
    BelowMarketSaleReason[BelowMarketSaleReason["TrusteesDeed"] = 41] = "TrusteesDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["UnknownReason"] = 42] = "UnknownReason";
    BelowMarketSaleReason[BelowMarketSaleReason["Foreclosure"] = 43] = "Foreclosure";
    BelowMarketSaleReason[BelowMarketSaleReason["EminentDomain"] = 44] = "EminentDomain";
})(BelowMarketSaleReason || (BelowMarketSaleReason = {}));
import { BreeamType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteResults.Types.BreeamType */
export { BreeamType };
import { BuildOut } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.BuildOut */
export { BuildOut };
/** CoStar.Api.SuiteResults.Types.TenancyState */
export var TenancyState;
(function (TenancyState) {
    TenancyState[TenancyState["Unknown"] = 0] = "Unknown";
    TenancyState[TenancyState["Single"] = 1] = "Single";
    TenancyState[TenancyState["Multi"] = 2] = "Multi";
})(TenancyState || (TenancyState = {}));
import { RentPlusType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.RentPlusType */
export { RentPlusType };
/** CoStar.Api.SuiteResults.Types.UseClass */
export var UseClass;
(function (UseClass) {
    UseClass[UseClass["None"] = 0] = "None";
    UseClass[UseClass["A1Shops"] = 1] = "A1Shops";
    UseClass[UseClass["A2FinancialAndProfessionalServices"] = 2] = "A2FinancialAndProfessionalServices";
    UseClass[UseClass["A3RestaurantsAndCafes"] = 3] = "A3RestaurantsAndCafes";
    UseClass[UseClass["A4DrinkingEstablishments"] = 4] = "A4DrinkingEstablishments";
    UseClass[UseClass["A5HotFoodTakeaway"] = 5] = "A5HotFoodTakeaway";
    UseClass[UseClass["NotSpecified"] = 6] = "NotSpecified";
    UseClass[UseClass["Class1Shops"] = 7] = "Class1Shops";
    UseClass[UseClass["Class2FinancialAndProfessional"] = 8] = "Class2FinancialAndProfessional";
    UseClass[UseClass["Class3FoodAndDrink"] = 9] = "Class3FoodAndDrink";
    UseClass[UseClass["SuiGeneris"] = 10] = "SuiGeneris";
    UseClass[UseClass["ClassBusiness"] = 11] = "ClassBusiness";
    UseClass[UseClass["Class5GeneralIndustrial"] = 12] = "Class5GeneralIndustrial";
    UseClass[UseClass["Class6StorageAndDistribution"] = 13] = "Class6StorageAndDistribution";
    UseClass[UseClass["Class7HotelsAndHostels"] = 14] = "Class7HotelsAndHostels";
    UseClass[UseClass["Class8ResidentialInstitutions"] = 15] = "Class8ResidentialInstitutions";
    UseClass[UseClass["Class9Houses"] = 16] = "Class9Houses";
    UseClass[UseClass["Class10NonresidentialInstitutions"] = 17] = "Class10NonresidentialInstitutions";
    UseClass[UseClass["Class11AssemblyAndLeisure"] = 18] = "Class11AssemblyAndLeisure";
    UseClass[UseClass["B1Business"] = 19] = "B1Business";
    UseClass[UseClass["B2GeneralIndustrial"] = 20] = "B2GeneralIndustrial";
    UseClass[UseClass["B8StorageAndDistribution"] = 21] = "B8StorageAndDistribution";
    UseClass[UseClass["C1Hotels"] = 22] = "C1Hotels";
    UseClass[UseClass["C2ResidentialInstitutions"] = 23] = "C2ResidentialInstitutions";
    UseClass[UseClass["C2ASecureResidentialInstitution"] = 24] = "C2ASecureResidentialInstitution";
    UseClass[UseClass["C3DwellingHouses"] = 25] = "C3DwellingHouses";
    UseClass[UseClass["D1NonresidentialInstitutions"] = 26] = "D1NonresidentialInstitutions";
    UseClass[UseClass["D2AssemblyAndLeisure"] = 27] = "D2AssemblyAndLeisure";
})(UseClass || (UseClass = {}));
/** CoStar.Api.SuiteResults.Types.TenantType */
export var TenantType;
(function (TenantType) {
    TenantType[TenantType["None"] = 0] = "None";
    TenantType[TenantType["Anchor"] = 1] = "Anchor";
    TenantType[TenantType["OutParcel"] = 2] = "OutParcel";
    TenantType[TenantType["Regular"] = 3] = "Regular";
    TenantType[TenantType["InOfficeBldg"] = 4] = "InOfficeBldg";
    TenantType[TenantType["InStoreTenant"] = 5] = "InStoreTenant";
    TenantType[TenantType["EndCap"] = 6] = "EndCap";
    TenantType[TenantType["Inline"] = 7] = "Inline";
    TenantType[TenantType["Vacant"] = 8] = "Vacant";
})(TenantType || (TenantType = {}));
import { MoveType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.MoveType */
export { MoveType };
/** CoStar.Api.SuiteResults.Types.ContactRole */
export var ContactRole;
(function (ContactRole) {
    ContactRole[ContactRole["None"] = 0] = "None";
    ContactRole[ContactRole["DeveloperConstruction"] = 1] = "DeveloperConstruction";
    ContactRole[ContactRole["Architect"] = 2] = "Architect";
    ContactRole[ContactRole["RecordedOwner"] = 3] = "RecordedOwner";
    ContactRole[ContactRole["PropertyManager"] = 4] = "PropertyManager";
    ContactRole[ContactRole["PrimaryLeasingCo"] = 6] = "PrimaryLeasingCo";
    ContactRole[ContactRole["TrueOwner"] = 7] = "TrueOwner";
    ContactRole[ContactRole["SignAgent"] = 8] = "SignAgent";
    ContactRole[ContactRole["AssetOrPortfolioManager"] = 9] = "AssetOrPortfolioManager";
    ContactRole[ContactRole["BuyerBroker"] = 10] = "BuyerBroker";
    ContactRole[ContactRole["ListingBroker"] = 11] = "ListingBroker";
    ContactRole[ContactRole["TenantRep"] = 15] = "TenantRep";
    ContactRole[ContactRole["DecisionMakerLeasing"] = 17] = "DecisionMakerLeasing";
    ContactRole[ContactRole["DecisionInfluencerLeasing"] = 18] = "DecisionInfluencerLeasing";
    ContactRole[ContactRole["LeasingCompany"] = 20] = "LeasingCompany";
    ContactRole[ContactRole["Principal"] = 26] = "Principal";
    ContactRole[ContactRole["SurveyContact"] = 27] = "SurveyContact";
    ContactRole[ContactRole["CenterMailContact"] = 28] = "CenterMailContact";
    ContactRole[ContactRole["CenterManager"] = 29] = "CenterManager";
    ContactRole[ContactRole["AsstAssocCenterManager"] = 30] = "AsstAssocCenterManager";
    ContactRole[ContactRole["Marketing"] = 31] = "Marketing";
    ContactRole[ContactRole["SpecialtyLeasingManager"] = 32] = "SpecialtyLeasingManager";
    ContactRole[ContactRole["BuildingSuperintendent"] = 33] = "BuildingSuperintendent";
    ContactRole[ContactRole["SecuritySupervisor"] = 34] = "SecuritySupervisor";
    ContactRole[ContactRole["AdvertisingManager"] = 35] = "AdvertisingManager";
    ContactRole[ContactRole["SpecialEventsManager"] = 36] = "SpecialEventsManager";
    ContactRole[ContactRole["PromotionDirectorManager"] = 37] = "PromotionDirectorManager";
    ContactRole[ContactRole["Other"] = 38] = "Other";
    ContactRole[ContactRole["RecordedSeller"] = 39] = "RecordedSeller";
    ContactRole[ContactRole["TrueSeller"] = 40] = "TrueSeller";
    ContactRole[ContactRole["Attorney"] = 41] = "Attorney";
    ContactRole[ContactRole["RecordedBuyer"] = 42] = "RecordedBuyer";
    ContactRole[ContactRole["TrueBuyer"] = 43] = "TrueBuyer";
    ContactRole[ContactRole["BuyerContact"] = 44] = "BuyerContact";
    ContactRole[ContactRole["SellerContact"] = 45] = "SellerContact";
    ContactRole[ContactRole["ListingAgent"] = 46] = "ListingAgent";
    ContactRole[ContactRole["LeasingAgent"] = 47] = "LeasingAgent";
    ContactRole[ContactRole["TenantContact"] = 48] = "TenantContact";
    ContactRole[ContactRole["Preparer"] = 49] = "Preparer";
    ContactRole[ContactRole["ListingAdmin"] = 50] = "ListingAdmin";
    ContactRole[ContactRole["SurveillanceOperator"] = 51] = "SurveillanceOperator";
    ContactRole[ContactRole["OwnerLeasingContact"] = 52] = "OwnerLeasingContact";
    ContactRole[ContactRole["WSRListingAdministrator"] = 53] = "WSRListingAdministrator";
    ContactRole[ContactRole["SocialAdminSetupContact"] = 54] = "SocialAdminSetupContact";
    ContactRole[ContactRole["OwnerListingAdministrator"] = 55] = "OwnerListingAdministrator";
    ContactRole[ContactRole["OwnerPermissionAdministrator"] = 56] = "OwnerPermissionAdministrator";
    ContactRole[ContactRole["ListingPermissionAdministrator"] = 57] = "ListingPermissionAdministrator";
    ContactRole[ContactRole["HotelMembershipCompany"] = 58] = "HotelMembershipCompany";
    ContactRole[ContactRole["AcquisitionsDispositions"] = 59] = "AcquisitionsDispositions";
    ContactRole[ContactRole["Leasing"] = 62] = "Leasing";
    ContactRole[ContactRole["Finance"] = 63] = "Finance";
    ContactRole[ContactRole["InvestorRelations"] = 64] = "InvestorRelations";
    ContactRole[ContactRole["Research"] = 66] = "Research";
    ContactRole[ContactRole["HrLegalItOperations"] = 67] = "HrLegalItOperations";
    ContactRole[ContactRole["DecisionMakerAcquisitions"] = 68] = "DecisionMakerAcquisitions";
    ContactRole[ContactRole["DecisionInfluencerAcquisitions"] = 69] = "DecisionInfluencerAcquisitions";
    ContactRole[ContactRole["DecisionMakerProductPurchase"] = 70] = "DecisionMakerProductPurchase";
    ContactRole[ContactRole["DecisionInfluencerProductPurchase"] = 71] = "DecisionInfluencerProductPurchase";
    ContactRole[ContactRole["Servicer"] = 72] = "Servicer";
    ContactRole[ContactRole["Borrower"] = 73] = "Borrower";
    ContactRole[ContactRole["SpecialServicer"] = 74] = "SpecialServicer";
    ContactRole[ContactRole["Originator"] = 75] = "Originator";
    ContactRole[ContactRole["Sponsor"] = 76] = "Sponsor";
    ContactRole[ContactRole["HotelOperator"] = 77] = "HotelOperator";
    ContactRole[ContactRole["Auctioneer"] = 78] = "Auctioneer";
    ContactRole[ContactRole["AuctionContact"] = 79] = "AuctionContact";
    ContactRole[ContactRole["GeneralContractor"] = 80] = "GeneralContractor";
    ContactRole[ContactRole["SubletContact"] = 1000] = "SubletContact";
    ContactRole[ContactRole["PreviousTrueOwner"] = 1001] = "PreviousTrueOwner";
    ContactRole[ContactRole["PreviousRecordedOwner"] = 1002] = "PreviousRecordedOwner";
    ContactRole[ContactRole["ExecutiveLeadershipPrincipal"] = 1003] = "ExecutiveLeadershipPrincipal";
    ContactRole[ContactRole["LeaseCompsAdministrator"] = 1004] = "LeaseCompsAdministrator";
    ContactRole[ContactRole["FeedContact"] = 1005] = "FeedContact";
})(ContactRole || (ContactRole = {}));
/** CoStar.Api.SuiteResults.Types.ContactSpecialtyType */
export var ContactSpecialtyType;
(function (ContactSpecialtyType) {
    ContactSpecialtyType[ContactSpecialtyType["None"] = 0] = "None";
    ContactSpecialtyType[ContactSpecialtyType["InvestmentSalesBroker"] = 1] = "InvestmentSalesBroker";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRep"] = 2] = "LandlordRep";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRepFlex"] = 3] = "LandlordRepFlex";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRepFullService"] = 4] = "LandlordRepFullService";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRepIndustrial"] = 5] = "LandlordRepIndustrial";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRepLand"] = 6] = "LandlordRepLand";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRepOffice"] = 7] = "LandlordRepOffice";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRepResidential"] = 8] = "LandlordRepResidential";
    ContactSpecialtyType[ContactSpecialtyType["LandlordRepRetail"] = 9] = "LandlordRepRetail";
    ContactSpecialtyType[ContactSpecialtyType["TenantRep"] = 10] = "TenantRep";
    ContactSpecialtyType[ContactSpecialtyType["TenantRepFlex"] = 11] = "TenantRepFlex";
    ContactSpecialtyType[ContactSpecialtyType["TenantRepFullService"] = 12] = "TenantRepFullService";
    ContactSpecialtyType[ContactSpecialtyType["TenantRepIndustrial"] = 13] = "TenantRepIndustrial";
    ContactSpecialtyType[ContactSpecialtyType["TenantRepOffice"] = 14] = "TenantRepOffice";
    ContactSpecialtyType[ContactSpecialtyType["TenantRepResidential"] = 15] = "TenantRepResidential";
    ContactSpecialtyType[ContactSpecialtyType["TenantRepRetail"] = 16] = "TenantRepRetail";
})(ContactSpecialtyType || (ContactSpecialtyType = {}));
import { LeaseBreakType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.LeaseBreakType */
export { LeaseBreakType };
/** CoStar.Api.SuiteResults.Types.RentType */
export var RentType;
(function (RentType) {
    RentType[RentType["None"] = 0] = "None";
    RentType[RentType["Asking"] = 1] = "Asking";
    RentType[RentType["Contract"] = 2] = "Contract";
    RentType[RentType["Effective"] = 3] = "Effective";
    RentType[RentType["NPVPerSFPeryr"] = 4] = "NPVPerSFPeryr";
    RentType[RentType["AnnuitizedNetEffectiveRent"] = 5] = "AnnuitizedNetEffectiveRent";
    RentType[RentType["EstimatedRent"] = 6] = "EstimatedRent";
})(RentType || (RentType = {}));
import { OccupancyType } from "../../../../CoStar/Api/SuitePlacards/Types/index.js";
/** CoStar.Api.SuiteResults.Types.OccupancyType */
export { OccupancyType };
import { OfficeType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuiteResults.Types.OfficeType */
export { OfficeType };
/** CoStar.Api.SuiteResults.Types.StoreType */
export var StoreType;
(function (StoreType) {
    StoreType[StoreType["None"] = 0] = "None";
    StoreType[StoreType["Bagel"] = 1] = "Bagel";
    StoreType[StoreType["Fitness"] = 2] = "Fitness";
    StoreType[StoreType["AutoShowroom"] = 3] = "AutoShowroom";
    StoreType[StoreType["FilmProcessing"] = 4] = "FilmProcessing";
    StoreType[StoreType["SpecialtyFoods"] = 5] = "SpecialtyFoods";
    StoreType[StoreType["CardGifts"] = 6] = "CardGifts";
    StoreType[StoreType["OtherRetail"] = 9] = "OtherRetail";
    StoreType[StoreType["IceCream"] = 10] = "IceCream";
    StoreType[StoreType["Books"] = 11] = "Books";
    StoreType[StoreType["OtherServices"] = 13] = "OtherServices";
    StoreType[StoreType["CandyNuts"] = 14] = "CandyNuts";
    StoreType[StoreType["ConsumerElectronics"] = 16] = "ConsumerElectronics";
    StoreType[StoreType["FloorCovering"] = 17] = "FloorCovering";
    StoreType[StoreType["MusicalInstruments"] = 18] = "MusicalInstruments";
    StoreType[StoreType["LeatherLuggagePurses"] = 19] = "LeatherLuggagePurses";
    StoreType[StoreType["Tobacco"] = 20] = "Tobacco";
    StoreType[StoreType["Automotive"] = 21] = "Automotive";
    StoreType[StoreType["GasolineStation"] = 22] = "GasolineStation";
    StoreType[StoreType["NailSalon"] = 23] = "NailSalon";
    StoreType[StoreType["SalonBarberSpa"] = 24] = "SalonBarberSpa";
    StoreType[StoreType["ChildrenApparel"] = 25] = "ChildrenApparel";
    StoreType[StoreType["CocktailBar"] = 26] = "CocktailBar";
    StoreType[StoreType["TravelAgent"] = 27] = "TravelAgent";
    StoreType[StoreType["HomeImprovement"] = 28] = "HomeImprovement";
    StoreType[StoreType["ChinaGlass"] = 29] = "ChinaGlass";
    StoreType[StoreType["Coffee"] = 30] = "Coffee";
    StoreType[StoreType["Bakery"] = 31] = "Bakery";
    StoreType[StoreType["Laundry"] = 32] = "Laundry";
    StoreType[StoreType["WindowCoverings"] = 33] = "WindowCoverings";
    StoreType[StoreType["ArtCrafts"] = 35] = "ArtCrafts";
    StoreType[StoreType["Supermarket"] = 36] = "Supermarket";
    StoreType[StoreType["MDDDS"] = 37] = "MDDDS";
    StoreType[StoreType["Florist"] = 38] = "Florist";
    StoreType[StoreType["KeyShop"] = 39] = "KeyShop";
    StoreType[StoreType["DeptStore"] = 40] = "DeptStore";
    StoreType[StoreType["OffPrice"] = 41] = "OffPrice";
    StoreType[StoreType["LadiesApparel"] = 42] = "LadiesApparel";
    StoreType[StoreType["Bank"] = 43] = "Bank";
    StoreType[StoreType["ArtGallery"] = 44] = "ArtGallery";
    StoreType[StoreType["OfficeSupply"] = 45] = "OfficeSupply";
    StoreType[StoreType["DrugStore"] = 46] = "DrugStore";
    StoreType[StoreType["LampsLighting"] = 47] = "LampsLighting";
    StoreType[StoreType["GameStore"] = 48] = "GameStore";
    StoreType[StoreType["Shoes"] = 49] = "Shoes";
    StoreType[StoreType["BowlingBilliards"] = 50] = "BowlingBilliards";
    StoreType[StoreType["Hardware"] = 52] = "Hardware";
    StoreType[StoreType["InvestmentService"] = 53] = "InvestmentService";
    StoreType[StoreType["AccountingTaxPrep"] = 56] = "AccountingTaxPrep";
    StoreType[StoreType["FastFood"] = 57] = "FastFood";
    StoreType[StoreType["HealthFood"] = 58] = "HealthFood";
    StoreType[StoreType["WirelessCommunications"] = 60] = "WirelessCommunications";
    StoreType[StoreType["Imports"] = 61] = "Imports";
    StoreType[StoreType["Newsstand"] = 62] = "Newsstand";
    StoreType[StoreType["Arcade"] = 63] = "Arcade";
    StoreType[StoreType["PetShopSupplies"] = 64] = "PetShopSupplies";
    StoreType[StoreType["FabricShop"] = 65] = "FabricShop";
    StoreType[StoreType["UnisexApparel"] = 66] = "UnisexApparel";
    StoreType[StoreType["FormalWear"] = 70] = "FormalWear";
    StoreType[StoreType["DiscountStore"] = 71] = "DiscountStore";
    StoreType[StoreType["Cinema"] = 72] = "Cinema";
    StoreType[StoreType["Accessory"] = 73] = "Accessory";
    StoreType[StoreType["Cafeteria"] = 74] = "Cafeteria";
    StoreType[StoreType["PaintWallpaper"] = 75] = "PaintWallpaper";
    StoreType[StoreType["WholesaleClub"] = 76] = "WholesaleClub";
    StoreType[StoreType["BikeShop"] = 77] = "BikeShop";
    StoreType[StoreType["FurnitureMattress"] = 78] = "FurnitureMattress";
    StoreType[StoreType["Toys"] = 79] = "Toys";
    StoreType[StoreType["HomeAccessories"] = 80] = "HomeAccessories";
    StoreType[StoreType["Photographer"] = 81] = "Photographer";
    StoreType[StoreType["ChurchCommHall"] = 83] = "ChurchCommHall";
    StoreType[StoreType["ConvenienceMarket"] = 84] = "ConvenienceMarket";
    StoreType[StoreType["OtherOffice"] = 86] = "OtherOffice";
    StoreType[StoreType["DonutShop"] = 87] = "DonutShop";
    StoreType[StoreType["Liquor"] = 88] = "Liquor";
    StoreType[StoreType["VideoGamesRental"] = 89] = "VideoGamesRental";
    StoreType[StoreType["Stationery"] = 90] = "Stationery";
    StoreType[StoreType["BusinessCopyPostalServices"] = 92] = "BusinessCopyPostalServices";
    StoreType[StoreType["DiscountGrocer"] = 93] = "DiscountGrocer";
    StoreType[StoreType["ATM"] = 94] = "ATM";
    StoreType[StoreType["Optical"] = 96] = "Optical";
    StoreType[StoreType["ButcherFishMarket"] = 97] = "ButcherFishMarket";
    StoreType[StoreType["Candles"] = 98] = "Candles";
    StoreType[StoreType["KitchenDiningAccessories"] = 99] = "KitchenDiningAccessories";
    StoreType[StoreType["Legal"] = 100] = "Legal";
    StoreType[StoreType["HealthCare"] = 101] = "HealthCare";
    StoreType[StoreType["SportingGoods"] = 102] = "SportingGoods";
    StoreType[StoreType["MusicVideoGames"] = 103] = "MusicVideoGames";
    StoreType[StoreType["Hobby"] = 104] = "Hobby";
    StoreType[StoreType["GourmetMarket"] = 105] = "GourmetMarket";
    StoreType[StoreType["Cameras"] = 106] = "Cameras";
    StoreType[StoreType["Appliances"] = 107] = "Appliances";
    StoreType[StoreType["MensApparel"] = 109] = "MensApparel";
    StoreType[StoreType["Dance"] = 110] = "Dance";
    StoreType[StoreType["ShoeRepair"] = 111] = "ShoeRepair";
    StoreType[StoreType["Daycare"] = 112] = "Daycare";
    StoreType[StoreType["Cleaners"] = 114] = "Cleaners";
    StoreType[StoreType["Cookies"] = 115] = "Cookies";
    StoreType[StoreType["Pretzels"] = 116] = "Pretzels";
    StoreType[StoreType["SavingsLoan"] = 117] = "SavingsLoan";
    StoreType[StoreType["RealEstate"] = 118] = "RealEstate";
    StoreType[StoreType["NutritionCenter"] = 119] = "NutritionCenter";
    StoreType[StoreType["Restaurant"] = 120] = "Restaurant";
    StoreType[StoreType["RentalShop"] = 121] = "RentalShop";
    StoreType[StoreType["HealthBeautyAids"] = 122] = "HealthBeautyAids";
    StoreType[StoreType["JewelryWatches"] = 124] = "JewelryWatches";
    StoreType[StoreType["EyewearAccessories"] = 125] = "EyewearAccessories";
    StoreType[StoreType["AutoRental"] = 126] = "AutoRental";
    StoreType[StoreType["GardenPatioPool"] = 127] = "GardenPatioPool";
    StoreType[StoreType["CheckCashQuickLoans"] = 128] = "CheckCashQuickLoans";
    StoreType[StoreType["DrinksJuices"] = 129] = "DrinksJuices";
    StoreType[StoreType["DollarVarietyThrift"] = 130] = "DollarVarietyThrift";
    StoreType[StoreType["Marine"] = 131] = "Marine";
    StoreType[StoreType["PawnShop"] = 132] = "PawnShop";
    StoreType[StoreType["TanningSalon"] = 133] = "TanningSalon";
    StoreType[StoreType["AnimalCareGroom"] = 134] = "AnimalCareGroom";
    StoreType[StoreType["FinanceCompany"] = 135] = "FinanceCompany";
    StoreType[StoreType["HotelMotel"] = 136] = "HotelMotel";
    StoreType[StoreType["Pizza"] = 137] = "Pizza";
    StoreType[StoreType["SubSandwich"] = 138] = "SubSandwich";
    StoreType[StoreType["Yogurt"] = 139] = "Yogurt";
    StoreType[StoreType["AutoMaintenanceOilChange"] = 140] = "AutoMaintenanceOilChange";
    StoreType[StoreType["Massage"] = 141] = "Massage";
    StoreType[StoreType["UrgentCare"] = 141] = "UrgentCare";
})(StoreType || (StoreType = {}));
